// import React from 'react';
import {
  Form,
  FormControl,
  Button,
  // Dropdown, Spinner
} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import FilterCollection from './FilterCollection';

const SearchBarHeader = (props) => {
  return (
    <Form name="SearchBar" onSubmit={(e) => e.preventDefault()}>
      {/* One row: search box, filter dropdown(s), then the buttons. Wraps on
          narrow screens. */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-end',
          gap: '12px',
        }}
      >
        <div
          style={{
            flex: '1 1 200px',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Form.Label
            htmlFor="catalog-search-input"
            style={{
              color: '#2C3E37',
              fontWeight: 'bold',
              fontSize: '16px',
              marginBottom: '0px',
            }}
          >
            Search Catalog
          </Form.Label>
          <FormControl
            id="catalog-search-input"
            type="search"
            placeholder="Search the catalog"
            value={props.searchQuery}
            onChange={props.handleChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                props.handleSearchClick();
              }
            }}
          />
        </div>
        <FilterCollection {...props} />
        <div style={{ display: 'flex', gap: '4px' }}>
          <Button
            variant="primary"
            style={{
              backgroundColor: '#2C3E37',
              fontWeight: 'bolder',
              fontSize: '16px',
              borderColor: '#43432b',
            }}
            onClick={props.handleSearchClick}
          >
            Search
          </Button>
          <Button
            style={{
              backgroundColor: '#bfc3c7',
              fontWeight: 'bolder',
              fontSize: '16px',
              borderColor: '#C3C7CB',
              color: 'black',
            }}
            onClick={props.handleClearClick}
            aria-label="Clear search"
          >
            Clear
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default SearchBarHeader;
